import React from 'react';
import { ACCOUNTS_EDIT } from 'routes';
import AccountBasic from './AccountBasic/AccountBasic';
import VariantChooser from './VariantSelection/VariantSelection';
import Investments from './Investments/Investments';
import Finances from './Finances/Finances';
import Plan from './Plan/Plan';
import Fees from './Fees/Fees';
import Contract from './Contract/Contract';

const defaultId = ':accountId';

const createRoute =
  (step: string) =>
  (accountId = defaultId) =>
    `${ACCOUNTS_EDIT(accountId)}/${step}`;

export const ACCOUNTS_EDIT_BASIC = createRoute('basic');
export const ACCOUNTS_EDIT_VARIANT = createRoute('variant');
export const ACCOUNTS_EDIT_FINANCE = createRoute('finances');
export const ACCOUNTS_EDIT_QUESTIONNAIRE = createRoute('investment');
export const ACCOUNTS_EDIT_PLAN = createRoute('plan');
export const ACCOUNTS_EDIT_FEES = createRoute('fees');
export const ACCOUNTS_EDIT_CONTRACT = createRoute('contract');

export const ACCOUNTS_EDIT_INVESTMENT = ACCOUNTS_EDIT_QUESTIONNAIRE;

export interface Params {
  accountId: string;
}

export const draftSteps: {
  title: string;
  id?: string;
  route?: (accountId?: string) => string;
  component?: () => JSX.Element;
}[] = [
  {
    title: 'accountStepper_basic',
    route: ACCOUNTS_EDIT_BASIC,
    component: () => <AccountBasic />,
  },
  {
    title: 'accountStepper_variantChooser',
    route: ACCOUNTS_EDIT_VARIANT,
    component: () => <VariantChooser />,
  },
  {
    title: 'accountStepper_financialQuestionnaire',
    route: ACCOUNTS_EDIT_FINANCE,
    component: () => <Finances />,
  },
  {
    title: 'accountStepper_investmentQuestionnaire',
    route: ACCOUNTS_EDIT_QUESTIONNAIRE,
    component: () => <Investments />,
  },
  {
    title: 'accountStepper_planProposal',
    route: ACCOUNTS_EDIT_PLAN,
    component: () => <Plan />,
  },
  {
    title: 'accountStepper_fees',
    route: ACCOUNTS_EDIT_FEES,
    component: () => <Fees />,
  },
  {
    title: 'accountStepper_contract',
    route: ACCOUNTS_EDIT_CONTRACT,
    component: () => <Contract />,
  },
];
